import * as classes from  '../styles.less';

const Eagerly_Tools_Cookie = require("./cookie").default;
globalThis.Eagerly_Tools_Cookie = Eagerly_Tools_Cookie;
